import { Plus, Minus, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

// The step form lets callers avoid keeping the zoom in React state.
type ZoomControlProps = {
  resetCompass: () => void;
} & (
  | { dynamicZoom: number; onZoom: (zoom: number) => void }
  | { onZoomBy: (delta: number) => void }
);

export const ZoomControl = (props: ZoomControlProps) => {
  const zoomBy = (delta: number) =>
    "onZoomBy" in props
      ? props.onZoomBy(delta)
      : props.onZoom(props.dynamicZoom + delta);
  return (
    <div className="flex flex-col gap-4 self-end">
      <div className="flex flex-col items-center justify-center self-end w-10 rounded-md bg-popover shadow-md">
        <Button
          variant="ghost"
          size="icon"
          className="mt-1.5"
          onClick={() => zoomBy(0.5)}
        >
          <Plus className="size-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="mb-1.5"
          onClick={() => zoomBy(-0.5)}
        >
          <Minus className="size-4" />
        </Button>
      </div>
      <div className="flex items-center justify-center self-end w-10 h-10 rounded-md bg-popover shadow-md">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => props.resetCompass()}
        >
          <Compass className="size-4" />
        </Button>
      </div>
    </div>
  );
};
